var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrns(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#3b3c5d",
    opacity: 0.3,
    width: 1.667,
    height: 10,
    rx: 0.833,
    transform: "translate(10.833 10.833) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b3c5d",
    opacity: 0.3,
    d: "M14.5,7.666A.833.833,0,1,1,14.5,6h.833a3.333,3.333,0,0,1,3.333,3.333V16a3.333,3.333,0,0,1-3.333,3.333h-10A3.333,3.333,0,0,1,2,16V9.326A3.333,3.333,0,0,1,5.333,5.993h.833a.833.833,0,0,1,0,1.667H5.333A1.667,1.667,0,0,0,3.667,9.326V16a1.667,1.667,0,0,0,1.667,1.667h10A1.667,1.667,0,0,0,17,16V9.332a1.667,1.667,0,0,0-1.667-1.667Z",
    transform: "translate(-0.333 -0.999)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b3c5d",
    d: "M13.244,10.244a.833.833,0,1,1,1.179,1.179l-2.5,2.5a.833.833,0,0,1-1.179,0l-2.5-2.5a.833.833,0,1,1,1.179-1.179l1.911,1.911Z",
    transform: "translate(-1.333 -1.667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrns);
export default __webpack_public_path__ + "static/media/grns.d4bff38980143a4d2de5970c49839470.svg";
export { ForwardRef as ReactComponent };